/**
 * Telling a placement tap apart from a camera orbit.
 *
 * Both start and end on the viewport, so the pointer's travel and dwell are
 * the only things that separate "put the module here" from "I was turning the
 * camera and happened to let go over this spot".
 */

export interface PointerSample {
  x: number;
  y: number;
  time: number;
  pointerId: number;
}

// A finger never lands perfectly still, so a few pixels of travel still counts
// as a tap.
export const TAP_MOVE_TOLERANCE_PX = 10;
// Longer than this and the user was holding, not tapping.
export const TAP_MAX_DURATION_MS = 700;

export function isPlacementTap(start: PointerSample, end: PointerSample): boolean {
  if (start.pointerId !== end.pointerId) {
    // A second finger ended; the gesture is a pinch, not a tap.
    return false;
  }
  const travelled = Math.hypot(end.x - start.x, end.y - start.y);
  if (travelled > TAP_MOVE_TOLERANCE_PX) {
    return false;
  }
  return end.time - start.time <= TAP_MAX_DURATION_MS;
}
